import { getDataFromServer } from '../../../util';

export class ClusterListModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchClusterList = async (payload) => {
    const params = {
      metaName: 'cluster'
    };

    const url = `${this.baseURL}/meta`;
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (Array.isArray(data) && data.length > 0) {
      return data.map((clusterItem) => {
        const clusterOtherInfo = String(clusterItem).split('_')[0].split('-');
        const clusterId = String(clusterItem).split(/_(.+)/)[1];

        const clusterQuarter = clusterOtherInfo[0];
        const clusterAlertYield = clusterOtherInfo[1]
          ? (Number(clusterOtherInfo[1]) * 100).toFixed(2)
          : 0.0;
        const clusterRiskScore = clusterOtherInfo[2]
          ? (Number(clusterOtherInfo[2]) * 100).toFixed(2)
          : 0.0;

        return {
          label: `${clusterQuarter}-${clusterAlertYield}%-${clusterRiskScore}`,
          value: clusterId
        };
      });
    }

    return [];
  };
}
